(function() {
    angular
        .module("app")
        .controller("SetLightLevelsModalController", SetLightLevelsModalController)

        SetLightLevelsModalController.$inject = [
        "$scope",
        "$timeout",
        "$uibModalInstance",
        "deviceID",
        "trackerID",
        "light1TargetLevel",
        "light2TargetLevel",
        "light3TargetLevel",
        "light4TargetLevel",
        "localProgramActive",
        "duskToDawnActive",
        "setLightDivOpacityLevel",
        "onStart",
        "onSuccess",
        "onFailure",
        "trackersService"
    ]

    function SetLightLevelsModalController(
        $scope,
        $timeout,
        $uibModalInstance,
        deviceID,
        trackerID,
        light1TargetLevel,
        light2TargetLevel,
        light3TargetLevel,
        light4TargetLevel,
        localProgramActive,
        duskToDawnActive,
        setLightDivOpacityLevel,
        onStart,
        onSuccess,
        onFailure,
        trackersService
    ){
        "use strict"

        $scope.setLightDivOpacityLevel = setLightDivOpacityLevel
        $scope.localProgramActive      = localProgramActive
        $scope.duskToDawnActive        = duskToDawnActive

        $scope.allowSave = false

        $scope.shouldShowOn = light1TargetLevel + light2TargetLevel + light3TargetLevel + light4TargetLevel === 0

        gtag("event", "display_change", { action: "begin", device_id: deviceID })

        const checkFormNeedsSave = () => {

            $scope.shouldShowOn = $scope.newLightLevels.light_1_target_level + $scope.newLightLevels.light_2_target_level + $scope.newLightLevels.light_3_target_level + $scope.newLightLevels.light_4_target_level === 0

            if (light1TargetLevel !== $scope.newLightLevels.light_1_target_level) { $scope.allowSave = true; return }
            if (light2TargetLevel !== $scope.newLightLevels.light_2_target_level) { $scope.allowSave = true; return }
            if (light3TargetLevel !== $scope.newLightLevels.light_3_target_level) { $scope.allowSave = true; return }
            if (light4TargetLevel !== $scope.newLightLevels.light_4_target_level) { $scope.allowSave = true; return }

            $scope.allowSave = false

        }

        $scope.sliderLightLevels = {
            value: 0,
            options: {
                floor:            0,
                ceil:             100,
                precision:        0,
                step:             10,
                getPointerColor:  () => { return "#0069aa" },
                onChange:         checkFormNeedsSave,
                translate:        (value) => { return value === 0 ? "OFF" : value + "%" },
                disableAnimation: true,
            }
        }

        $scope.newLightLevels = {
            light_1_target_level: light1TargetLevel,
            light_2_target_level: light2TargetLevel,
            light_3_target_level: light3TargetLevel,
            light_4_target_level: light4TargetLevel
        }

        $scope.setLightLevels = () => {

            onStart()

            const handleOnSuccess = (data) => {
                gtag("event", "display_change", { action: "complete", device_id: deviceID, values: Object.values($scope.newLightLevels) })
                onSuccess(data)
            }

            $uibModalInstance.close(
                trackersService.solarLightTowerSetLightLevels(trackerID, $scope.newLightLevels, handleOnSuccess, onFailure)
            )
        }

        $scope.setAllLightsOnOff = (method) => {

            const lightLevel = method === "on" ? 50 : 0

            $scope.newLightLevels.light_1_target_level = lightLevel
            $scope.newLightLevels.light_2_target_level = lightLevel
            $scope.newLightLevels.light_3_target_level = lightLevel
            $scope.newLightLevels.light_4_target_level = lightLevel

            checkFormNeedsSave()

        }

        $scope.cancel = () => {
            gtag("event", "display_change", { action: "cancel", device_id: deviceID })
            $uibModalInstance.dismiss("cancel")
        }

        $timeout(() => {
            $scope.$broadcast('rzSliderForceRender')
        })
    }
})()
